import { Label, Typography } from 'fronton-react';
import React from 'react';
import { DURATION_OF_USE, DurationOfUseType } from '../../constants';
import { useTranslation } from 'react-i18next';
import { labelStyles, reviewAdditionalInfoWrapper, typographyStyles } from './review.styles';

type Props = {
  isVerified?: boolean;
  durationOfUse?: DurationOfUseType | string;
} & React.HTMLAttributes<HTMLElement>;

const isDurationOfUseType = (value: string): value is DurationOfUseType => value in DURATION_OF_USE;

export const ReviewAdditionalInfo: React.FC<Props> = ({ isVerified, durationOfUse, ...htmlProps }) => {
  const { t } = useTranslation();

  return (
    <div className={reviewAdditionalInfoWrapper} {...htmlProps}>
      {durationOfUse && (
        <Typography variant="caption" color="text-minor">
          {isDurationOfUseType(durationOfUse) ? t(`reviews.form.term.${durationOfUse}`) : durationOfUse}
        </Typography>
      )}
      {isVerified && (
        <Label className={labelStyles} borderColor="brand-primary" background="background-primary">
          <Typography className={typographyStyles} size="regular" variant="mini">
            {t('reviews.review.confirmed-purchase')}
          </Typography>
        </Label>
      )}
    </div>
  );
};
